import React from 'react';

import {
  LocationTabs,
  useGetSettingPageIdFromUrlParams,
} from '@portals/framework';
import {
  PartnerFeatureFlagsType,
  PartnerPortalCapabilities,
  TabType,
} from '@portals/types';

import { GroupsTable } from './groups/GroupsTable';
import { UsersTable } from './UsersTable';

const TABS: TabType<PartnerFeatureFlagsType, PartnerPortalCapabilities>[] = [
  {
    id: 'users',
    name: 'users',
    title: 'Users',
    Component: UsersTable,
  },
  {
    id: 'groups',
    name: 'groups',
    title: 'Groups',
    Component: GroupsTable,
  },
];

export function UsersAndGroups() {
  const settingPageId = useGetSettingPageIdFromUrlParams();

  return (
    <LocationTabs<
      PartnerFeatureFlagsType,
      PartnerPortalCapabilities,
      any,
      { settingPageId: typeof settingPageId }
    >
      tabs={TABS}
      pathParams={{ settingPageId }}
    />
  );
}
